import LoLRedeemCodeModal from './LoLRedeemCodeModal';

export default LoLRedeemCodeModal;
